export default __webpack_public_path__ + "54c2ffb7717f21032023b707a1599e50.svg";